import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import qs from 'qs';

import InsuranceContractList from 'components/InsuranceContractList';
import InsuranceContractSearch from 'components/InsuranceContractSearch';
import Pagination from 'components/Pagination/Pagination';
import { fetchAllInsuranceContracts } from 'actions/insuranceContracts';
import { getAllInsuranceContracts, getPageCount } from 'reducers';

class AllInsuranceContracts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: 'all',
      loading: false,
    };

    this.onSearch = this.onSearch.bind(this);
    this.buildSubscriptionQuery = this.buildSubscriptionQuery.bind(this);
  }

  componentDidMount() {
    this.fetchContracts();
  }

  componentDidUpdate(oldProps, oldState) {
    if (oldState.status !== this.state.status) {
      return this.fetchContracts();
    }

    if (oldProps.page !== this.props.page) {
      return this.fetchContracts();
    }

    if (oldProps.att_subscription !== this.props.att_subscription) {
      return this.fetchContracts();
    }

    if (oldProps.quick_subscription !== this.props.quick_subscription) {
      return this.fetchContracts();
    }

    if (oldProps.user_profile !== this.props.user_profile) {
      return this.fetchContracts();
    }
  }

  fetchContracts() {
    const {
      fetchAllInsuranceContracts,
      page,
      att_subscription,
      quick_subscription,
      user_profile,
    } = this.props;
    const { status } = this.state;

    this.setState({ loading: true });

    let params = {
      att_subscription,
      quick_subscription,
      user_profile,
      // subscription_carrier: 'att',
    };
    if (status !== 'all') {
      params.status = status;
    }

    return fetchAllInsuranceContracts(page, params).then(() =>
      this.setState({ loading: false }),
    );
  }

  onSearch(filters) {
    const { history } = this.props;
    history.push({
      pathname: '/device-protection/contracts',
      search: '?' + new URLSearchParams({ page: 1, ...filters }).toString(),
    });
  }

  handleClassName(className) {
    const { status } = this.state;

    return status === className ? 'active' : '';
  }

  handleFilteringByDate(status) {
    this.setState({ status });

    this.props.history.push(
      `/device-protection/contracts?page=${1}${this.buildSubscriptionQuery()}`,
    );
  }

  buildSubscriptionQuery() {
    const { att_subscription, quick_subscription, user_profile } = this.props;
    let filters = {};
    if (att_subscription) {
      filters.att_subscription = att_subscription;
    }

    if (quick_subscription) {
      filters.quick_subscription = quick_subscription;
    }

    if (user_profile) {
      filters.user_profile = user_profile;
    }

    if (filters && Object.keys(filters).length)
      return `&${new URLSearchParams(filters).toString()}`;

    return '';
  }

  render() {
    const {
      contracts,
      pageCount,
      page,
      att_subscription,
      quick_subscription,
      user_profile,
    } = this.props;
    const { loading } = this.state;
    const subscriptionQuery = this.buildSubscriptionQuery();

    return (
      <div>
        <h1>All Device Protection Contracts</h1>
        <InsuranceContractSearch
          initialValues={{
            att_subscription: att_subscription || '',
            quick_subscription: quick_subscription || '',
            user_profile: user_profile || '',
          }}
          user_profile={user_profile}
          onSubmit={this.onSearch}
        />
        <br />
        <div>
          <button
            className={`button_link ${this.handleClassName('all')}`}
            onClick={() => this.handleFilteringByDate('all')}
          >
            All
          </button>{' '}
          |
          <button
            className={`button_link ${this.handleClassName('pending')}`}
            onClick={() => this.handleFilteringByDate('pending')}
          >
            Pending
          </button>{' '}
          |
          <button
            className={`button_link ${this.handleClassName('active')}`}
            onClick={() => this.handleFilteringByDate('active')}
          >
            Active
          </button>
        </div>
        <br />
        <InsuranceContractList contracts={contracts} loading={loading} />
        {!loading && (
          <Pagination
            count={pageCount}
            current={page}
            url={(pageNum) =>
              `/device-protection/contracts?page=${pageNum}${subscriptionQuery}`
            }
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, { location: { search } }) => {
  const {
    page = 1,
    att_subscription,
    quick_subscription,
    user_profile,
  } = qs.parse(search, { ignoreQueryPrefix: true });
  return {
    contracts: getAllInsuranceContracts(
      state,
      page,
      att_subscription,
      user_profile,
    ),
    pageCount: getPageCount(state, 'insuranceContracts', `fetchAll`, page),
    page,
    att_subscription,
    quick_subscription,
    user_profile,
  };
};

const mapDispatchToProps = {
  fetchAllInsuranceContracts,
};

AllInsuranceContracts = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AllInsuranceContracts),
);

export default AllInsuranceContracts;
